import clsx from "clsx";
import React from "react";
import { makeStyles } from "tss-react/mui";

import { useCurrentSubscriptionExpired } from "@dashboard/workspaces/api/helpers";
import { styled } from "@mui/material/styles";

const PageContainerBase = styled("div")(({ theme }) => ({
    width: "100%",
    minHeight: "100vh",
    overflow: "hidden",
    padding: theme.spacing(4, 8),
    flexGrow: 1,
    backgroundColor: theme.palette.emteria.background.default,

    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2, 2),
    },
}));

const useStyles = makeStyles()({
    subscriptionExpired: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    fitViewport: {
        height: "100vh",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
    },
});

type PageContainerProps = React.ComponentProps<typeof PageContainerBase> & {
    disableExpiredLayout?: boolean;
    /** Bounds the container to the viewport height so children can use flex-fill layouts (sticky headers, pinned footers). */
    fitViewport?: boolean;
};

export const PageContainer = ({ className, disableExpiredLayout, fitViewport, ...rest }: PageContainerProps) => {
    const isExpired = useCurrentSubscriptionExpired();
    const { classes } = useStyles();

    return (
        <PageContainerBase
            {...rest}
            className={clsx(
                className,
                fitViewport && classes.fitViewport,
                isExpired && !disableExpiredLayout && classes.subscriptionExpired,
            )}
        />
    );
};
